import { ApiResponse, LoginResponse } from "../../models/ApiResponse";
import { LoginRequest } from "../../models/requestModels/loginRequest";
import { axiosRequests } from "../axiosRequest";

export const LoginAgent = {
  login: (user: LoginRequest) =>
    axiosRequests.post<LoginResponse>("/auth/public/login", user),
  refreshToken: () => axiosRequests.get<LoginResponse>("/auth/public/refreshToken"),
  logout: () => axiosRequests.delete<ApiResponse>("/auth/public/logout")
};
